import GeneratedDataSourceServiceApi from "./generated/GeneratedDataSourceServiceApi"

class DataSourceServiceApi extends GeneratedDataSourceServiceApi {

}

export const dataSourceServiceApi = new DataSourceServiceApi()
